import { render, staticRenderFns } from "./ListaDeArquivos.vue?vue&type=template&id=6b7007ca&"
import script from "./ListaDeArquivos.vue?vue&type=script&lang=js&"
export * from "./ListaDeArquivos.vue?vue&type=script&lang=js&"
import style0 from "./ListaDeArquivos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports